// import {  } from '../../_services/login.service.js';
import { putCompany, putToken, putUserId, putRol, putUserName } from '../../_utils/storage_handler';
import { MAIN_ROUTES, APP_ROUTES } from '../../_config/routes';
import { ROLES } from '../../_config/roles';
import { buildLoginBody, validateLogin } from './login.inputs';
import { loginService, privateLoginService } from '../../_services/user.service';

const redirectByRol = (rol) => {
    if(rol === ROLES.root || rol === ROLES.operator){
        document.location.href = `${MAIN_ROUTES.app_modules}${APP_ROUTES.orders_box_inm}`;
    } else if(rol === ROLES.admin){
        document.location.href = `${MAIN_ROUTES.app_modules}${APP_ROUTES.products}`;
    } else if(rol === ROLES.accounter){
        document.location.href = `${MAIN_ROUTES.app_modules}${APP_ROUTES.pocket_balance}`;
    } else if(rol === ROLES.seller){
        document.location.href = `${MAIN_ROUTES.app_modules}${APP_ROUTES.create_order}`;
    } else if(rol === ROLES.color){
        document.location.href = `${MAIN_ROUTES.app_modules}${APP_ROUTES.colors}`;
    } else if(rol === ROLES.validator){
        document.location.href = `${MAIN_ROUTES.app_modules}${APP_ROUTES.validation}`;
    } else if(rol === ROLES.marcados){
        document.location.href = `${MAIN_ROUTES.app_modules}${APP_ROUTES.marked}`;
    } else if(rol === ROLES.crudo){
        document.location.href = `${MAIN_ROUTES.app_modules}${APP_ROUTES.crude}`;
    } else if(rol === ROLES.tejeduria){
        document.location.href = `${MAIN_ROUTES.app_modules}${APP_ROUTES.weaving}`;
    } else if(rol === ROLES.tintoreria){
        document.location.href = `${MAIN_ROUTES.app_modules}${APP_ROUTES.dry_cleaner}`;
    } else if(rol === ROLES.enrollado){
        document.location.href = `${MAIN_ROUTES.app_modules}${APP_ROUTES.rolled_up}`;
    } else if(rol === ROLES.despacho){
        document.location.href = `${MAIN_ROUTES.app_modules}${APP_ROUTES.despatch}`;
    } else if(rol === ROLES.remisionar){
        document.location.href = `${MAIN_ROUTES.app_modules}${APP_ROUTES.remission}`;
    } else if(rol === ROLES.viewer || rol === ROLES.viewerSP){
        document.location.href = `${MAIN_ROUTES.app_modules}${APP_ROUTES.general_view}`;
    } else {
        alert('Config Render login');
    }
}

export const loginEvent = async (isPrivate = false) => {
    let body = buildLoginBody();
    validateLogin(body);
    let res = isPrivate ? await privateLoginService(body) : await loginService(body);
    if(! res.ok){
        throw new Error(res.error ? res.error : 'Failed to fetch. Server error');
    }
    let rol = res.data.rol;
    putUserId(res.data.uuid);
    putCompany(res.data.company);
    putToken(res.data.token);
    putRol(rol);
    putUserName(res.data.full_name)
    redirectByRol(rol);
    return res;
}

